/*
 * @Author: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-10-21 21:05:46
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2024-02-06 19:57:25
 * @FilePath: \fe-crm\src\store\modules\layout.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia';
export const useLayoutStore = defineStore('getLayoutStore', {
  state: () => ({
    dragIng: false,
    changeViewId: sessionStorage.getItem('changeViewId') ? JSON.parse(sessionStorage.getItem('changeViewId')) : {}, //存储当前选中的实体和视图id,
    menuOpenKeys: sessionStorage.getItem('menuOpenKeys') ? JSON.parse(sessionStorage.getItem('menuOpenKeys')) : [],
    settingBackRoute: sessionStorage.getItem('settingBackRoute') ? JSON.parse(sessionStorage.getItem('settingBackRoute')) : {}, //存储点击设置中心时的当前路由name，用于设置中心关闭后返回
    dragList: [],
    newDraggableIndex: -1,
    dragLayoutType: null, //拖拽类型 兼容子表单
    selectSubIndex: null //选中的子表单的字段索引
  }),
  actions: {
    setDrag(val) {
      this.dragIng = val;
    },
    setDragLayoutType(type) {
      this.dragLayoutType = type;
    },
    setSelectSubIndex(type) {
      this.selectSubIndex = type;
    },
    setDragElement(e, dragData) {
      this.dragList = dragData || []; //被拖拽入的元素
      this.newDraggableIndex = (e && e.newDraggableIndex) || -1; //被拖拽入的位置
    },
    viewChange(viewId, entity) {
      this.changeViewId[entity] = viewId; //对象entityId:viewId
      sessionStorage.setItem('changeViewId', JSON.stringify(this.changeViewId));
    },
    setMenuOpenKeys(keys) {
      this.menuOpenKeys = [keys];
      sessionStorage.setItem('menuOpenKeys', JSON.stringify([keys])); // 序列化
    },
    // 设置返回路由
    setSettingBackRoute(routeInfo) {
      this.settingBackRoute = routeInfo;
      sessionStorage.setItem('settingBackRoute', JSON.stringify(routeInfo));
    },
    clear(key) {
      this[key] = null; // 或初始值
      sessionStorage.removeItem(key);
    }
  }
});

export default useLayoutStore;
